﻿import { createContext, useContext as useReactContext } from 'react';

import { AssignedAccessCode, AssignedStudent, ContentDeliverable, License, MostRestrictiveLicense, TransactionDetails } from 'apis/TransactionApi';
import type { AccessCodesContextValue } from 'pages/access_codes/AccessCodesWrapper';
import { DEFAULT_TAB_CONTEXT, TabsContext, useContext } from 'components/Tabs';

export type TransactionData = {
	accessCodes?: AssignedAccessCode[];
	activity?: any;
	content?: ContentDeliverable[];
	contentOriginal?: ContentDeliverable[];
	defaultAccessCode?: string;
	inactiveOrders?: License[];
	licenseHistory?: License[];
	licenses?: License[];
	mostRestrictiveLicense?: MostRestrictiveLicense;
	performance?: any;

	// true while the non-Details tab data is still loading in the background
	secondaryLoading?: boolean;
	students?: AssignedStudent[];
	testContent?: ContentDeliverable[];
	transactionDetails?: TransactionDetails;
	transactionDetailsOriginal?: TransactionDetails;
}

export const TransactionDetailsContext = createContext<TabsContext<TransactionData>>(DEFAULT_TAB_CONTEXT);
TransactionDetailsContext.displayName = 'TransactionDetailsContext';

export const useTransactionDetails = () => useContext(TransactionDetailsContext);

export const AccessCodesContext = createContext<AccessCodesContextValue>({
    permissions: {
        ContentSelect: false,
        Create: false,
        Edit: false,
        ExpiringLicense: false,
        GroupPermission: false,
        IsPostFiltering: false,
        MyAccessCodes: false,
        OverviewPermission: false,
        PartnerId: 0,
        PartnerType: 0,
        Search: false,
        StudentFeatureFlag: false,
        StudentPermission: false
    },
    studentPermissions: {
        ArchivedStudents: false,
        CourseReporting: false,
        CustomFieldsFlag: false,
        Edit: false,
        EditPII: false,
        EditUsername: false,
        GroupPermission: false,
        Import: false,
        IsPostFiltering: false,
        Login: false,
        NewFieldAccess: false,
        OverviewPermission: false,
        PartnerId: 0,
        PartnerType: 0,
        Search: false,
        TransactionFeatureFlag: false,
        TransactionPermission: false,
        ViewPII: false
    }
});
AccessCodesContext.displayName = 'AccessCodesContext';

export const useAccessCodes = () => useReactContext(AccessCodesContext);